import { useId } from '@reach/auto-id';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { height, width, space, size } from 'styled-system';
import { Text } from '@pleo-io/telescope-text';
import { pink500, spacing60, spacing20, circle, shade600 } from '@pleo-io/telescope-tokens';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var _excluded = ["height", "width", "size", "color"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];

var Loading = function Loading(_ref) {
  var dotsHeight = _ref.height,
      dotsWidth = _ref.width,
      dotSize = _ref.size,
      color = _ref.color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return React.createElement(Dots, Object.assign({
    height: dotsHeight,
    width: dotsWidth,
    role: "progressbar",
    "aria-live": "polite"
  }, props), React.createElement(Dot, {
    delay: 0,
    size: dotSize,
    color: color
  }), React.createElement(Dot, {
    delay: 1,
    size: dotSize,
    color: color
  }), React.createElement(Dot, {
    delay: 2,
    size: dotSize,
    color: color
  }));
};

var defaultProps = {
  size: 20,
  color: pink500
};
Loading.defaultProps = defaultProps;

var LoadingPage = function LoadingPage(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var id = useId();
  return React.createElement(PageContainer, {
    "data-telescope-loading-page": true
  }, React.createElement(Loading, Object.assign({}, props, {
    "aria-labelledby": id
  })), React.createElement(Text, {
    id: id,
    variant: "medium-default"
  }, children));
};

LoadingPage.defaultProps = /*#__PURE__*/_extends({}, defaultProps, {
  color: pink500
});

var LoadingOverlay = function LoadingOverlay(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  var id = useId();
  return React.createElement(OverlayContainer, {
    "data-telescope-loading-overlay": true
  }, React.createElement(Loading, Object.assign({}, props, {
    "aria-labelledby": id
  })), React.createElement(Text, {
    id: id,
    variant: "medium-default"
  }, children));
};

LoadingOverlay.defaultProps = /*#__PURE__*/_extends({}, defaultProps, {
  color: pink500
});
var animation = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    0%,\n    80%,\n    100% {\n        transform: scale3d(0.3, 0.3, 1);\n    }\n\n    40% {\n        transform: scale3d(1.2, 1.2, 1);\n    }\n"])));
var Dots = /*#__PURE__*/styled.div(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n    ", "\n    ", "\n"])), height, width, space);
var PageContainer = /*#__PURE__*/styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n\n    ", " {\n        padding-top: ", ";\n        padding-bottom: ", ";\n    }\n"])), Dots, spacing60, spacing60);
var OverlayContainer = /*#__PURE__*/styled.div(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    transform: translate(-50%, -50%);\n\n    ", " {\n        padding-top: ", ";\n        padding-bottom: ", ";\n    }\n"])), Dots, spacing60, spacing60);
var Dot = /*#__PURE__*/styled.div(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: inline-block;\n    margin-right: ", ";\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    background-color: ", ";\n    border-radius: ", ";\n    animation: ", " 1.2s infinite ease-in-out;\n    animation-delay: ", "ms;\n    animation-fill-mode: both;\n    ", "\n    ", "\n\n    &:last-child {\n        margin-right: 0;\n    }\n"])), spacing20, function (_ref4) {
  var color = _ref4.color;
  return color;
}, circle, animation, function (_ref5) {
  var _ref5$delay = _ref5.delay,
      delay = _ref5$delay === void 0 ? 0 : _ref5$delay;
  return delay * 160;
}, size, space);
Dot.defaultProps = {
  color: shade600
};
export { Dot, Dots, Loading, LoadingOverlay, LoadingPage };